<template>
  <div class="privacy-container">
    <!-- 加载状态 -->
    <div v-if="loading" class="loading-box">
      <el-spinner size="40" />
      <p>政策内容加载中...</p>
    </div>

    <!-- 接口返回HTML内容渲染 -->
    <div
      v-else-if="htmlContent"
      class="policy-content"
      v-html="htmlContent"
    ></div>


  </div>
</template>

<script>
    export default {
        data(){
            return {
                loading: true,
                htmlContent: ''
            }
        },
        mounted: function () {
            this.getPrivacy()
        },
        methods: {
            async getPrivacy () {
                try{
                    const params = {
                    }
                    let res = await window.instance.get('https://uat.lingshutong.cn/common-service/account/privacyClause', params)
                    if (res.data.code === 200) {
                        res = res.data.data
                        this.htmlContent = res.privacyClause
                    }
                } finally {
                    this.loading = false
                }
            },
        }

    }
</script>

<style scoped>
.privacy-container {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  color: #333;
  line-height: 1.8;
}

.policy-header {
  text-align: center;
  margin-bottom: 40px;
  border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}
.policy-header h1 {
  font-size: 26px;
  margin: 0 0 10px;
}
.update-time {
  color: #666;
  font-size: 14px;
}

.policy-content section {
  margin-bottom: 30px;
}
.policy-content h2 {
  font-size: 18px;
  margin: 20px 0 12px;
  color: #222;
}
.policy-content h3 {
  font-size: 16px;
  margin: 16px 0 8px;
  color: #444;
}
.policy-content p {
  font-size: 15px;
  text-indent: 2em;
  margin: 8px 0;
}
.policy-content ul {
  padding-left: 2em;
}
.policy-content li {
  font-size: 15px;
  margin: 6px 0;
}

.policy-footer {
  margin-top: 50px;
  text-align: center;
  padding-top: 30px;
  border-top: 1px solid #eee;
}
.policy-footer .el-button {
  margin: 0 10px;
  width: 140px;
  height: 42px;
}
</style>



// WEBPACK FOOTER //
// src/pages/privacyPolicy.vue